<template>
  <card class="account-widget">
    <div class="title">{{ title }}</div>
    <div :class="$slots['default'] ? 'content' : 'empty'">
      <slot></slot>
    </div>
    <div class="cta-button">
      <base-button
        type="primary"
        :class="`${buttonEnabled ? '' : ' disabled'}`"
        @click="$emit(name + 'Clicked')"
        >{{ buttonText }}</base-button
      >
    </div>
  </card>
</template>

<script>
export default {
  name: "account-widget",
  props: {
    name: {
      type: String,
      description: "Widget name",
    },
    title: {
      type: String,
      description: "Widget title",
    },
    buttonText: {
      type: String,
      description: "CTA button text",
    },
    buttonEnabled: {
      type: Boolean,
      default: true,
      description: "Enable or disable CTA button",
    },
  },
};
</script>

<style lang="scss">
.account-widget {
  align-items: center;
  text-align: center;

  .card-body {
    width: 100%;
  }

  .title {
    font-weight: 700;
  }

  .empty {
    padding: 0.5rem;
  }

  .content {
    padding: 2rem 0.5rem;
    font-size: 0.875rem;
  }
}
</style>
